import { Order } from './order';
import { Department, Organization } from './organization';

export type DeliverySchedule = {
    lateOrdersCount: number | null;
    noDeadlineOrdersCount: number | null;
    plannedOrders: Order[];
};

export enum DeliveryScheduleFinishedFilter {
    NOT_FINISHED = 'NOT_FINISHED',
    FINISHED = 'FINISHED',
    BOTH = 'BOTH',
}

export type DeliveryScheduleFilters = {
    clinic: Organization | null;
    department: Department | null;
    finishedFilter: DeliveryScheduleFinishedFilter;
};

export type DeliveryScheduleInput = {
    date: Date | null;
    clinicId?: string;
    departmentId?: string;
    finishedFilter: DeliveryScheduleFinishedFilter;
    isExternal: boolean;
};

export enum DeliveryNoteSelection {
    SENT_ON_DATE = 'SENT_ON_DATE',
    FINISHED_ON_DATE = 'FINISHED_ON_DATE',
}

export type DeliveryScheduleDeliveryNotesInput = {
    date: Date;
    clinicId?: string;
    departmentId?: string;
    selection: DeliveryNoteSelection;
};

export type DeliveryNoteOrder = {
    _id: string;
    orderId: string;
    hasDeliveryNotePdf: boolean;
};
